import React from "react";
import "./loadinganimation.css";
const LoadingAnimation = () => {
  return (
    <div className="loading-animation">
      <table>
        <tbody>
          <tr>
            <td class="td-1">
              <span></span>
            </td>
            <td class="td-2">
              <span></span>
            </td>
            <td class="td-3">
              <span></span>
            </td>
            <td class="td-4"></td>
            <td class="td-5">
              <span></span>
            </td>
          </tr>
          <tr>
            <td class="td-1">
              <span></span>
            </td>
            <td class="td-2">
              <span></span>
            </td>
            <td class="td-3">
              <span></span>
            </td>
            <td class="td-4"></td>
            <td class="td-5">
              <span></span>
            </td>
          </tr>
          <tr>
            <td class="td-1">
              <span></span>
            </td>
            <td class="td-2">
              <span></span>
            </td>
            <td class="td-3">
              <span></span>
            </td>
            <td class="td-4"></td>
            <td class="td-5">
              <span></span>
            </td>
          </tr>
          <tr>
            <td class="td-1">
              <span></span>
            </td>
            <td class="td-2">
              <span></span>
            </td>
            <td class="td-3">
              <span></span>
            </td>
            <td class="td-4"></td>
            <td class="td-5">
              <span></span>
            </td>
          </tr>
          <tr>
            <td class="td-1">
              <span></span>
            </td>
            <td class="td-2">
              <span></span>
            </td>
            <td class="td-3">
              <span></span>
            </td>
            <td class="td-4"></td>
            <td class="td-5">
              <span></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LoadingAnimation;
